module.exports = __webpack_public_path__ + "img/sqs_sqsmodelsnft.2434fa3.png";